import { parse as parse8601 } from 'iso8601-duration';

/**
 * ISO 8601 DURATION в количество дней
 * @example "P1M" => 30
 */
export const iso8601DurationToDays = (isoDuration: string, { daysInMonth = 30, daysInYears = 365 } = {}): number => {
  try {
    const { years = 0, months = 0, weeks = 0, days = 0 } = parse8601(isoDuration);
    return years * daysInYears + months * daysInMonth + weeks * 7 + days;
  } catch {
    return 0;
  }
};
